export const previewItems: string[] = [
  'Drill Card — Ground Ball Battles, Volume 2',
  'Coach Script Box — the words, ready to read aloud',
  'Full Field Diagram — every zone labeled',
  'The Draw, step by step — Volume 3',
  'Assessment Rubric — four levels, already filled in',
  'The 12-Week Season Plan — Volume 6',
]
